import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { StoreAvailableAdjustmentRequestAction } from './store-available-adjustment-request.actions';
import {
  StoreAvailableAdjustmentRequestListContent,
  StoreAvailableAdjustmentRequestSearchCriteria,
  storeAvailableAdjustmentRequestStatusList
} from '../../model/store-available-adjustment-request.model';

export interface StoreAvailableAdjustmentRequestState
  extends EntityState<StoreAvailableAdjustmentRequestListContent> {
  isLoading: boolean;
  selected: any[];
  criteriaObject: StoreAvailableAdjustmentRequestSearchCriteria;
  totalElements: number;
  totalPages: number;
  auditLogs: any;
  storeAvailableAdjustmentRequestView: any;
}

export const adapter: EntityAdapter<StoreAvailableAdjustmentRequestListContent> =
  createEntityAdapter<StoreAvailableAdjustmentRequestListContent>({
    selectId: (model: StoreAvailableAdjustmentRequestListContent) => model.requestNo
  });

export const initialState: StoreAvailableAdjustmentRequestState = adapter.getInitialState({
  isLoading: false,
  selected: [],
  criteriaObject: {
    page: 0,
    size: 20,
    status: storeAvailableAdjustmentRequestStatusList[0].value
  },
  totalElements: null,
  totalPages: 20,
  auditLogs: [],
  storeAvailableAdjustmentRequestView: null
});

export const storeAvailableAdjustmentRequestReducer = createReducer<StoreAvailableAdjustmentRequestState>(
  initialState,
  on(StoreAvailableAdjustmentRequestAction.responseList, (state, action): StoreAvailableAdjustmentRequestState => {
    return {
      ...state,
      selected: action.data.content,
      totalElements: action.data.totalElements,
      isLoading: false,
      criteriaObject: {
        ...state.criteriaObject,
        page: action.data.page,
        size: action.data.size
      }
    };
  })
);
